import { createFileRoute } from '@tanstack/react-router'
import { HelpSupportPage } from '@/pages/help-support/HelpSupportPage'

export const Route = createFileRoute('/help-support')({
  component: RouteComponent,
})

function RouteComponent() {
  return <HelpSupportPage />
}
